module.exports = __webpack_public_path__ + "c931aaa189afa74fe94ceeb2a96d7acc.svg";